import { render } from "./ImageTextFlexComponent.vue?vue&type=template&id=335af6be&scoped=true"
import script from "./ImageTextFlexComponent.vue?vue&type=script&lang=js"
export * from "./ImageTextFlexComponent.vue?vue&type=script&lang=js"

import "./ImageTextFlexComponent.vue?vue&type=style&index=0&id=335af6be&lang=scss&scoped=true"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335af6be"]])

export default __exports__